<template>
    <button type="submit" :disabled="disabled" class="sign-up-button" :class="buttonClass">
        <slot></slot>
    </button>
</template>
<script>
    export default {
        name: 'SignUpButton',
        props: {
            currentApp: {
                type: String,
                default: 'community'
            },
            disabled: {
                type: [String, Boolean],
                default: false
            }
        },
        computed: {
            buttonClass () {
                return 'sign-up-button--' + this.currentApp;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .sign-up-button {
        appearance: none;
        -webkit-appearance: none;
        border: none;
        display: block;
        width: 100%;
        border-radius: 2px;
        padding: 11.25px;
        color: #FFF;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 18px;

        &, &--community {
            background: #F43;
            box-shadow: inset 0px -2px 0px #DB2B22;

            &:active { background: darken(#F43, 10%); }
        }

        &--print, &--workbench {
            background: #3AD;
            box-shadow: inset 0px -2px 0px #1E91C2;

            &:active { background: darken(#3AD, 10%); }
        }

        &--partner_program {
            background: #3077E2;
            box-shadow: 0px 6px 12px rgba(0, 51, 147, 0.2);
            border-radius: 10px;
            &:active { background: darken(#3077e2, 10%); }
        }

        &--shop {
            background: #003393;
            border: 1px solid #1755C8;
            box-sizing: border-box;
            box-shadow: 0px 5px 10px rgba(0, 51, 147, 0.3), inset 0px -2px 0px #1755C8;
            border-radius: 5px;

            &:active { background: darken(#003393, 10%); }
        }

        &:disabled {
            opacity: 0.5;
        }
    }
</style>